export default "__VITE_PUBLIC_ASSET__41c5318e__"